import React, { useState } from 'react';
import { Tag, Text, TipShareBreakdown } from 'components';
import { Size } from 'design/types';
import { DEFAULT_POOL_NAME, ICalculatorRule, IFormCalculatorRule } from 'types';
import { toTitleCase } from 'utils/strings';
import { ItemContainer, StyledIconButton } from '../../styles';
import { Column, DivWithGap, StyledButtonText, StyledRow } from './styles';

interface ITipShareItemProps {
  tipShare: IFormCalculatorRule | ICalculatorRule;
  disabled?: boolean;
  isAdvanced?: boolean;
  alwaysVisible?: boolean;
  onEdit?(): void;
  onDelete?(): void;
}

export const TipShareItem: React.FC<ITipShareItemProps> = ({ tipShare, disabled, isAdvanced, alwaysVisible, onEdit, onDelete }) => {
  const [rulesVisible, setRulesVisible] = useState(alwaysVisible || false);
  return (
    <ItemContainer data-cy="tip-share-item">
      <StyledRow>
        <Column>
          <DivWithGap>
            <Text size="small" fontWeight="semibold" capitalize>
              {tipShare?.default ? `${DEFAULT_POOL_NAME} Rules` : `${toTitleCase(tipShare?.contributor?.name)} Share`}
            </Text>
            {tipShare?.sharePolicy?.isSharedTerminal && tipShare.default === false && <Tag label="Shared POS" size={Size.SMALL} />}
          </DivWithGap>

          {!alwaysVisible && <StyledButtonText label={rulesVisible ? 'Hide Rules' : 'View Rules'} onClick={() => setRulesVisible(!rulesVisible)} />}
        </Column>

        {!disabled && (
          <div>
            <StyledIconButton label="Edit" appearance="white" size="small" icon="Edit" data-cy="edit-button" onClick={onEdit} disabled={disabled} />
            <StyledIconButton label="Remove" onClick={onDelete} appearance="white" size="small" icon="Close" data-cy="remove-button" disabled={disabled} />
          </div>
        )}
      </StyledRow>

      {rulesVisible && <TipShareBreakdown tipShare={tipShare} isAdvanced={isAdvanced} />}
    </ItemContainer>
  );
};
